import { getCognitoConfig } from './config';

export interface CognitoRefreshResponse {
  AuthenticationResult?: {
    AccessToken: string;
    IdToken: string;
    ExpiresIn?: number;
    TokenType?: string;
  };
  __type?: string;
  message?: string;
}

export interface RefreshTokensResult {
  response?: CognitoRefreshResponse;
  error?: unknown;
}

/**
 * Exchange a Cognito refresh token for new access + ID tokens.
 * Used by SSO SPAs and redux-saga websocket initialisation.
 */
export const fetchRefreshedTokens = (
  refreshToken: string,
  apiEnv: string
): Promise<RefreshTokensResult> => {
  const cognito = getCognitoConfig(apiEnv);

  return fetch(`https://cognito-idp.${cognito.REGION}.amazonaws.com/`, {
    headers: {
      'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth',
      'Content-Type': 'application/x-amz-json-1.1',
      'X-Amz-User-Agent': 'aws-amplify/0.1.x js',
    },
    mode: 'cors',
    cache: 'no-cache',
    method: 'POST',
    body: JSON.stringify({
      ClientId: cognito.APP_CLIENT_ID,
      AuthFlow: 'REFRESH_TOKEN_AUTH',
      AuthParameters: {
        REFRESH_TOKEN: refreshToken,
      },
    }),
  })
    .then((r) => r.json())
    .then((response: CognitoRefreshResponse) => ({ response }))
    .catch((error) => ({ error }));
};
